'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REALTIME_API_V1 = exports.REALTIME_API_V1 = '1';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/constants/realtimeApiVersions.js
// module id = 406
// module chunks = 2 3